import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app/app.service';

@Component({
  selector: 'app-consultation',
  templateUrl: './consultation.component.html',
  styleUrls: ['./consultation.component.css']
})
export class ConsultationComponent implements OnInit {
  public pageBasic: boolean = true;
  public pageCategory: boolean = false;
  public pageHair: boolean = false;
  public pageBeard: boolean = false;
  public pagePerformance: boolean = false;
  public pageWeight: boolean = false;
  public pageSkin: boolean = false;
  public pageSuggestion: boolean = false;
  public categories = [];
  public suggestedProduct;
  public productList = [];
  public categoryHandle;
  public user;
  public userDetails = {
    'fName': '',
    'lName': '',
    'email': '',
    'number': '',
    'age': '',
    'weight': 0,
    'height': 0,
    'category': '',
    'BMI': 0,
    'hair': {
      'question1': '',
      'question2': '',
      'question3': '',
      'question4': '',
      'question5': '',
      'question6': '',
      'question7': '',
      'question8': '',
      'question9': '',
      'question10': '',
      'question11': '',
      'question12': '',
      'question13': '',
      'question14': '',
      'question15': '',
      'question16': '',
      'question17': '',
      'question18': '',
      'question19': '',
      'question20': '',
    },
    'performance': {
      'question1': '',
      'question2': '',
      'question3': '',
      'question4': '',
      'question5': '',
      'question6': '',
      'question7': '',
      'question8': '',
      'question9': '',
      'question10': '',
      'question11': '',
      'question12': '',
      'question13': '',
      'question14': '',
      'question15': '',
      'question16': '',
      'question17': '',
      'question18': '',
      'question19': '',
      'question20': '',
    },
    'beard': {
      'question1': '',
      'question2': '',
      'question3': '',
      'question4': '',
      'question5': '',
      'question6': '',
      'question7': '',
      'question8': '',
      'question9': '',
      'question10': '',
      'question11': '',
      'question12': '',
      'question13': '',
      'question14': '',
      'question15': '',
      'question16': '',
      'question17': '',
      'question18': '',
      'question19': '',
      'question20': '',
    },
    'weight_loss': {
      'question1': '',
      'question2': '',
      'question3': '',
      'question4': '',
      'question5': '',
      'question6': '',
      'question7': '',
      'question8': '',
      'question9': '',
      'question10': '',
      'question11': '',
      'question12': '',
      'question13': '',
      'question14': '',
      'question15': '',
      'question16': '',
      'question17': '',
      'question18': '',
      'question19': '',
      'question20': '',
    },
    'skin': {
      'question1': '',
      'question2': '',
      'question3': '',
      'question4': '',
      'question5': '',
      'question6': '',
      'question7': '',
      'question8': '',
      'question9': '',
      'question10': '',
      'question11': '',
      'question12': '',
      'question13': '',
      'question14': '',
      'question15': '',
      'question16': '',
      'question17': '',
      'question18': '',
      'question19': '',
      'question20': '',
    }
  }
  public weight;
  public height;
  constructor(private appService: AppService) {
    this.categories = ['Hair', 'Beard', 'Performance', 'Weight Loss', 'Skin']
  }

  ngOnInit(): void {
    // this.productSuggestion()
    this.user = JSON.parse(localStorage.getItem('user'))
  }

  navigateNext(page) {
    if (page == 'basic') {
      this.pageBasic = false;
      this.pageCategory = true
    } else if (page == 'category') {
      this.pageCategory = false;
      switch (this.userDetails.category) {
        case 'Hair':
          this.pageHair = true;
          break;
        case 'Beard':
          this.pageBeard = true;
          break;
        case 'Performance':
          this.pagePerformance = true;
          break;
        case 'Weight Loss':
          this.pageWeight = true;
          break;
        case 'Skin':
          this.pageSkin = true;
          break;
      }
    } else if (page == 'suggestion') {
      this.appService.submitLead({ ...this.userDetails, ...{ agent: this.user.id } }).subscribe((response) => { });
      this.pageHair = this.pagePerformance = this.pageSkin = this.pageWeight = this.pageBeard = false;
      this.pageSuggestion = true
      switch (this.userDetails.category) {
        case 'Hair':
          this.categoryHandle = 'hair-1'
          if (this.userDetails.hair.question1 == 'stage1') {
            this.productSuggestion(this.categoryHandle, 6933666726052)
            // Hair Oil Biotin
          } else if (this.userDetails.hair.question1 == 'stage2') {
            this.productSuggestion(this.categoryHandle, 6920580530340)
            // Anit Hairfall kit
          } else if ((this.userDetails.hair.question1 == 'stage3' || this.userDetails.hair.question1 == 'stage4') && this.userDetails.hair.question3 == 'no' && parseInt(this.userDetails.age) > 30) {
            this.productSuggestion(this.categoryHandle, 6920192950436)
            // Hair Growth Kit
          } else if ((this.userDetails.hair.question1 == 'stage3' || this.userDetails.hair.question1 == 'stage4') && (this.userDetails.hair.question3 == 'yes' || this.userDetails.hair.question4 == 'yes')) {
            this.productSuggestion(this.categoryHandle, 6920580530340)
            // Anit Hairfall kit
          } else if ((this.userDetails.hair.question1 == 'stage5' || this.userDetails.hair.question1 == 'stage6') && this.userDetails.hair.question3 == 'no' && this.userDetails.hair.question4 == 'no' && parseInt(this.userDetails.age) > 30) {
            this.productSuggestion(this.categoryHandle, 6920192950436, 5805045711012)
            // Hair growth kit + Fin Tb 
          } else if ((this.userDetails.hair.question1 == 'stage5' || this.userDetails.hair.question1 == 'stage6') && this.userDetails.hair.question3 == 'no' && this.userDetails.hair.question4 == 'no' && parseInt(this.userDetails.age) <= 30) {
            this.productSuggestion(this.categoryHandle, 6920192950436)
            // Hair growth kit
          } else if ((this.userDetails.hair.question1 == 'stage5' || this.userDetails.hair.question1 == 'stage6') && (this.userDetails.hair.question3 == 'yes' || this.userDetails.hair.question4 == 'yes') && parseInt(this.userDetails.age) > 30) {
            this.productSuggestion(this.categoryHandle, 6920563753124, 5805045711012)
            // Hair Vitalizer and Dermaroller combo + Fin Tb 
          } else if ((this.userDetails.hair.question1 == 'stage5' || this.userDetails.hair.question1 == 'stage6') && (this.userDetails.hair.question3 == 'yes' || this.userDetails.hair.question4 == 'yes') && parseInt(this.userDetails.age) <= 30) {
            this.productSuggestion(this.categoryHandle, 6920580530340)
            // Anit Hairfall kit
          } else {
            this.productSuggestion(this.categoryHandle, 6732124520612)
            // Anit Hairfall kit
          }
          break;
        case 'Beard':
          this.categoryHandle = 'beard'
          if (this.userDetails.beard.question2 == 'patchy' || this.userDetails.beard.question2 == 'no beard' || this.userDetails.beard.question2 == 'very less') {
            this.productSuggestion(this.categoryHandle, 6980058677412)
            // Beard Growth Kit
          } else if (this.userDetails.beard.question2 == 'excellednt') {
            this.productSuggestion(this.categoryHandle, 6743341072548)
            // Beard Care Kit
          }
          break;
        case 'Performance':
          this.categoryHandle = 'performance'
          if ((this.userDetails.performance.question2 == 'sometimes' || this.userDetails.performance.question2 == 'most of the times') && this.userDetails.performance.question3 == 'normal' && this.userDetails.performance.question4 == 'no') {
            this.productSuggestion(this.categoryHandle, 6607101493412)
            // Stamina & Virility Combo (Surge Max & Prescription Medicine)
          } else if ((this.userDetails.performance.question2 == 'sometimes' || this.userDetails.performance.question2 == 'most of the times') && this.userDetails.performance.question3 == 'normal' && this.userDetails.performance.question4 != 'no') {
            this.productSuggestion(this.categoryHandle, 6718215651492)
            // surgemax
          } else if ((this.userDetails.performance.question2 == 'sometimes' || this.userDetails.performance.question2 == 'most of the times') && this.userDetails.performance.question3 == 'too Early' && this.userDetails.performance.question4 == 'no') {
            this.productSuggestion(this.categoryHandle, 5853650682020)
            // the complete performance kit
          } else if ((this.userDetails.performance.question2 == 'sometimes' || this.userDetails.performance.question2 == 'most of the times') && this.userDetails.performance.question3 == 'too Early' && this.userDetails.performance.question4 != 'no') {
            this.productSuggestion(this.categoryHandle, 6734347174052)
            // Sexual Wellness Combo
          } else if (this.userDetails.performance.question3 == 'too Early' && this.userDetails.performance.question2 == 'no issues') {
            this.productSuggestion(this.categoryHandle, 6734347174052)
            // Sexual Wellness Combo
          } else if (this.userDetails.performance.question2 == 'no issues' && this.userDetails.performance.question4 == 'no') {
            this.productSuggestion(this.categoryHandle, 6718215651492)
            // surgemax
          } else {
            this.productSuggestion(this.categoryHandle, 6734347174052)
            // Sexual Wellness Combo
          }
          break;
        case 'Weight Loss':
          this.calculateBMI()
          this.categoryHandle = 'weight-loss';
          if (this.userDetails.BMI > 25) {
            this.productSuggestion(this.categoryHandle, 6679222288548)
            // Advanced Weight Loss Pack
          } else if (this.userDetails.BMI > 22 && this.userDetails.BMI <= 25) {
            this.productSuggestion(this.categoryHandle, 6774754902180)
            // Fat Burning Combo
          } else {
            this.productSuggestion(this.categoryHandle, 6766304428196)
            // Slimming Oil
          }
          break;
        case 'Skin':
          this.categoryHandle = 'skin'
          if (this.userDetails.skin.question4 == 'None') {
            if (this.userDetails.skin.question1 == 'pores') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7516963406072, 6826132668580)
              // FACEWASH, FACETONER, GLOWSKINSERUM
            }
            if (this.userDetails.skin.question1 == 'pigmentation') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7524810391800, 6906399129764)
              // Face wash + Alpha arbutin + JAde Roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'acne') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6826093478052)
              // Face wash  + Anti Acne
            }
            if (this.userDetails.skin.question1 == 'aging') {
              this.productSuggestion(this.categoryHandle, 6877087105188)
              // Anti Aging serum+JAde Roller+Gua Sha: 
            }
            if (this.userDetails.skin.question1 == 'darkcircles') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6826132668580, 6906399129764)
              // Face wash + Gloww Skin + Jade roller+ Gua Sha
            }
            if (this.userDetails.skin.question1 == 'spots') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6826093478052, 6826132668580)
              // Face Wash + Anti Acne + Gloww Serum
            }
            if (this.userDetails.skin.question1 == 'dullskin') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7516963406072, 6826132668580, 6906399129764)
              // Face wash + Toner + Gloww serum + JAde Roller + Gua Sha
            }
          } else if (this.userDetails.skin.question4 == 'Vitamin C') {
            if (this.userDetails.skin.question1 == 'pores') {
              this.productSuggestion(this.categoryHandle, 7637440266488)
              // Combo of Face Wash+Toner
            }
            if (this.userDetails.skin.question1 == 'pigmentation') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7524810391800, 6906399129764)
              // Face wash + Alpha arbutin + JAde Roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'acne') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6826093478052)
              // Face wash  + Anti Acne
            }
            if (this.userDetails.skin.question1 == 'aging') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6825877635236, 6934521708708)
              // Face wash + Anti Aging + Derma Roller
            }
            if (this.userDetails.skin.question1 == 'darkcircles') {
              this.productSuggestion(this.categoryHandle, 7637452128504)
              // Combo of Face Toner + Alpha Arbutin
            }
            if (this.userDetails.skin.question1 == 'spots') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6826093478052, 6906399129764)
              // Face Wash + Anti Acne + JAde Roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'dullskin') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7516963406072, 6906399129764)
              // Face wash + Toner + JAde Roller + Gua Sha
            }
          } else if (this.userDetails.skin.question4 == 'Salicylic Acid') {
            if (this.userDetails.skin.question1 == 'pores') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7516963406072, 6826132668580)
              // Face Wash + Toner + Gloww Skin serum
            }
            if (this.userDetails.skin.question1 == 'pigmentation') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7524810391800, 6906399129764)
              // Face wash + Alpha arbutin + JAde Roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'acne') {
              this.productSuggestion(this.categoryHandle, 7637452128504)
              // Combo of Face Toner + Alpha Arbutin
            }
            if (this.userDetails.skin.question1 == 'aging') {
              this.productSuggestion(this.categoryHandle, 6973442228388)
              // Forever Young Kit(Gloww Serum+Anti Aging)
            }
            if (this.userDetails.skin.question1 == 'darkcircles') {
              this.productSuggestion(this.categoryHandle, 7637473067256)
              // Combo of Face wash + Gloww Skin
            }
            if (this.userDetails.skin.question1 == 'spots') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7524810391800, 6826132668580)
              // Face Wash + Alpha Arbutin + Gloww Skin serum
            }
            if (this.userDetails.skin.question1 == 'dullskin') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7516963406072, 6826132668580, 6906399129764)
              // Face wash + Toner + Gloww serum + JAde Roller + Gua Sha
            }
          } else if (this.userDetails.skin.question4 == 'Retinol') {
            if (this.userDetails.skin.question1 == 'pores') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7516963406072, 6826132668580)
              // Face Wash + Toner + Gloww skin serum
            }
            if (this.userDetails.skin.question1 == 'pigmentation') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7524810391800, 6906399129764)
              // Face wash + Alpha arbutin + JAde Roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'acne') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6826093478052)
              // Face wash  + Anti Acne
            }
            if (this.userDetails.skin.question1 == 'aging') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7524810391800, 6934521708708)
              // Face wash + Alpha Arbutin + Derma Roller
            }
            if (this.userDetails.skin.question1 == 'darkcircles') {
              this.productSuggestion(this.categoryHandle, 7637452128504)
              // Combo of Face Toner + Alpha Arbutin
            }
            if (this.userDetails.skin.question1 == 'spots') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6826093478052, 6906399129764)
              // Face Wash + Anti Acne + JAde Roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'dullskin') {
              this.productSuggestion(this.categoryHandle, 7637440266488)
              // Combo of Face Wash and Face Toner:
            }
          } else if (this.userDetails.skin.question4 == 'Niacinamide') {
            if (this.userDetails.skin.question1 == 'pores') {
              this.productSuggestion(this.categoryHandle, 7524809375992)
              // Face wash
            }
            if (this.userDetails.skin.question1 == 'pigmentation') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7524810391800, 6906399129764)
              // Face wash + Alpha arbutin + JAde Roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'acne') {
              this.productSuggestion(this.categoryHandle, 7637452128504)
              // Combo of Face Toner + Alpha Arbutin
            }
            if (this.userDetails.skin.question1 == 'aging') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6825877635236, 6934521708708)
              // Face wash + Anti Aging + Derma Roller
            }
            if (this.userDetails.skin.question1 == 'darkcircles') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6906399129764)
              // Face wash + Jade Roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'spots') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7524810391800, 6906399129764)
              // Face Wash + Alpha Arbutin + Jade roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'dullskin') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6906399129764)
              // Face wash + JAde Roller + Gua Sha
            }
          } else if (this.userDetails.skin.question4 == 'Kojic Acid') {
            if (this.userDetails.skin.question1 == 'pores') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7516963406072, 6826132668580)
              // Face Wash + Toner + Gloww Skin serum
            }
            if (this.userDetails.skin.question1 == 'pigmentation') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7524810391800, 6906399129764)
              // Face wash +Anti Acne + JAde Roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'acne') {
              this.productSuggestion(this.categoryHandle, 6876951576740)
              // Acne Control Kit: Anti Acne+ Biotin
            }
            if (this.userDetails.skin.question1 == 'aging') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6825877635236, 6934521708708)
              // Face wash + Anti Aging + Derma Roller
            }
            if (this.userDetails.skin.question1 == 'darkcircles') {
              this.productSuggestion(this.categoryHandle, 6877027401892)
              // Combo of Gloww Skin + JAde Roller + Gua Sha
            }
            if (this.userDetails.skin.question1 == 'spots') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 6826093478052, 6826132668580, 6906399129764)
              // Face Wash + Anti Acne + Gloww Serum + Jade Roller 
            }
            if (this.userDetails.skin.question1 == 'dullskin') {
              this.productSuggestion(this.categoryHandle, 7524809375992, 7516963406072, 6826132668580, 6906399129764)
              // Face wash + Toner + Gloww serum + JAde Roller + Gua Sha
            }
          }
          break;

      }
    }
  }

  async productSuggestion(handle: string, ...args) {
    let list = await this.appService.getProductsByCategory(handle)
    this.productList = list['products'].filter(item => args.includes(item.id))
  }

  calculateBMI() {
    this.userDetails.BMI = this.userDetails.weight / (this.userDetails.height * this.userDetails.height) * 10000
  }

  navigatePrevious(page) {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
    if (page == 'basic') return
    else if (page == 'category') {
      this.pageCategory = false;
      this.pageBasic = true;
    } else {
      this.pageCategory = true;
      switch (page) {
        case 'hair':
          this.pageHair = false;
          break;
        case 'beard':
          this.pageBeard = false;
          break;
        case 'performance':
          this.pagePerformance = false;
          break;
        case 'weight loss':
          this.pageWeight = false;
          break;
        case 'skin':
          this.pageSkin = false;
          break;
      }
    }
  }

  onReset() {
    this.pageHair = this.pagePerformance = this.pageSkin = this.pageWeight = this.pageBeard = this.pageSuggestion = false;
    this.pageBasic = true
    this.userDetails = {
      'fName': '',
      'lName': '',
      'email': '',
      'number': '',
      'age': '',
      'weight': 0,
      'height': 0,
      'category': '',
      'BMI': 0,
      'hair': {
        'question1': '',
        'question2': '',
        'question3': '',
        'question4': '',
        'question5': '',
        'question6': '',
        'question7': '',
        'question8': '',
        'question9': '',
        'question10': '',
        'question11': '',
        'question12': '',
        'question13': '',
        'question14': '',
        'question15': '',
        'question16': '',
        'question17': '',
        'question18': '',
        'question19': '',
        'question20': '',
      },
      'performance': {
        'question1': '',
        'question2': '',
        'question3': '',
        'question4': '',
        'question5': '',
        'question6': '',
        'question7': '',
        'question8': '',
        'question9': '',
        'question10': '',
        'question11': '',
        'question12': '',
        'question13': '',
        'question14': '',
        'question15': '',
        'question16': '',
        'question17': '',
        'question18': '',
        'question19': '',
        'question20': '',

      },
      'beard': {
        'question1': '',
        'question2': '',
        'question3': '',
        'question4': '',
        'question5': '',
        'question6': '',
        'question7': '',
        'question8': '',
        'question9': '',
        'question10': '',
        'question11': '',
        'question12': '',
        'question13': '',
        'question14': '',
        'question15': '',
        'question16': '',
        'question17': '',
        'question18': '',
        'question19': '',
        'question20': '',
      },
      'weight_loss': {
        'question1': '',
        'question2': '',
        'question3': '',
        'question4': '',
        'question5': '',
        'question6': '',
        'question7': '',
        'question8': '',
        'question9': '',
        'question10': '',
        'question11': '',
        'question12': '',
        'question13': '',
        'question14': '',
        'question15': '',
        'question16': '',
        'question17': '',
        'question18': '',
        'question19': '',
        'question20': '',
      },
      'skin': {
        'question1': '',
        'question2': '',
        'question3': '',
        'question4': '',
        'question5': '',
        'question6': '',
        'question7': '',
        'question8': '',
        'question9': '',
        'question10': '',
        'question11': '',
        'question12': '',
        'question13': '',
        'question14': '',
        'question15': '',
        'question16': '',
        'question17': '',
        'question18': '',
        'question19': '',
        'question20': '',
      }
    }
  }

}
